import { type Color } from '@mui/material'

// reason: these are the color tokens so they are hardcoded
/* eslint-disable @dhl/mui/no-hardcoded-colors */
export const dhlRed = {
  100: '#80A5C9',
  200: '#6693BE',
  300: '#4D81B3',
  400: '#336FA9',
  500: '#195D9E',
  600: '#004B93',
  700: '#004384',
  800: '#003C76',
  900: '#003467',
} satisfies Partial<Color>
